(function() {
    'use strict';
    wo$(function() {
        var landingPageSearchController = {
            init: function() {
                wo$('[data-enable-when-ready]').removeAttr('disabled');
                landingPageSearchController.registerNotifications();
                landingPageSearchController.initHistoryTracker();
            },
            registerNotifications: function() {
                WhistleOut.notifications.add(function(notification, data) {
                    if (notification === 'FilterChanged') {
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        landingPageSearchController.updateFilters(data.criteria, data.type !== 'Sort' && data.type !== 'Keyword');
                    }
                });
            },

            updateFilters: function(criteria, fullReload) {
                WhistleOut.startProgress('#search-results-partial', 0.1, 50);
                var queryString = '?';
                if (fullReload) {
                    criteria.showAll = false;
                    criteria.hideWidenResults = false;
                    queryString += WhistleOut.MobilePhones.generatePhonesQueryString(criteria);
                    location.href = criteria.searchUrl + queryString;
                    return;
                }
                var resultsUrl = criteria.searchResultsAjaxUrl;
                queryString += WhistleOut.MobilePhones.generatePhonesQueryString(criteria);
                wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                wo$.ajax({
                    url: resultsUrl + queryString,
                    type: 'GET',
                    success: function(result) {
                        var $results = wo$('#search-results-partial');
                        $results.html(result);
                        WhistleOut.notifications.fire('SearchResultsRendered', { criteria: criteria });
                        WhistleOut.endProgress();
                        wo$('[data-enable-when-ready]').removeAttr('disabled');
                        wo$(window).resize();
                    },
                    error: function() {
                        WhistleOut.endProgress();
                    }
                });
            },

            initHistoryTracker: function () {
                WhistleOut.initHistoryTracker(landingPageSearchController);
            }
        };

        landingPageSearchController.init();
    });

}());